import Axios from 'api/client';
import { ComparisonType, DateOptionsDateRange } from 'components/account-overview-chart/types';
import { Campaign } from 'types/domain';

type RewardStatus = 'clicked' | 'claimed';

interface FetchOnboardingTasksParams {
    accountId: number;
}

interface UpdateRewardStatusRequest {
    accountId: number;
    status: RewardStatus;
}

interface OnboardingTasksResponse {
    first_campaign: Campaign | null;
    raised: number;
    has_campaign: boolean;
    has_transaction: boolean;
    has_payout_account: boolean;
    reward_status: RewardStatus | null;
    can_use_reward?: boolean;
}

const fetchOnboardingTasks = ({ accountId }: FetchOnboardingTasksParams) =>
    Axios.get<OnboardingTasksResponse>(`/accounts/${accountId}/onboarding-tasks`).then(
        response => response.data,
    );

const updateRewardStatus = ({ status, accountId }: UpdateRewardStatusRequest) =>
    Axios.post(`/accounts/${accountId}/reward`, {
        status,
    });

const fetchChartStats = (
    accountId: number,
    selectedCampaignId: number,
    interval: string,
    dates: DateOptionsDateRange,
    comparisonType: ComparisonType,
) => {
    const campaignIds = selectedCampaignId === 0 ? '' : `campaign_ids[]=${selectedCampaignId}`;
    const query = `/accounts/${accountId}/metrics/donation-stats-by-interval?${campaignIds}&interval=${interval}&comparison_type=${comparisonType}&start_date=${encodeURIComponent(
        dates.start_date,
    )}&end_date=${encodeURIComponent(dates.end_date)}`;

    return Axios.get(query).then(response => response.data);
};

export { fetchOnboardingTasks, fetchChartStats, updateRewardStatus };
export type { OnboardingTasksResponse };
